import {
  GSToggle,
  GSFileSelect,
  GSButton,
  GSItemList,
} from "golfstatus_react_components";
import {
  faArrowCircleUp,
  faExternalLinkSquareAlt,
  faLink,
  faLinkSlash,
  faUserShield,
} from "@fortawesome/free-solid-svg-icons";
import OrganizationLinkItem from "../components/settings-preferences/organization-link-item";
import { validations } from "golfstatus_react_components";

export const getSettingsPages = () => {
  let pages = [
    {
      label: "Organization Details",
      details: "Edit organization name, logo, and currency locale.",
      isExternal: false,
      url: "details",
      hidden: false,
    },
    {
      label: "Events List",
      details:
        "Personalize the events list with a hero image and external links.",
      isExternal: false,
      url: "events",
      hidden: false,
    },
    {
      label: "Privacy",
      details: "Manage visibility for all tournaments.",
      isExternal: false,
      hidden: false,
      url: "privacy",
    },
    {
      label: "Payment Settings",
      details: "Manage connected payment accounts.",
      isExternal: false,
      hidden: false,
      url: "payments",
    },
  ];
  return pages?.filter?.((p) => !p.hidden);
};

export const getSettingsEventsPages = () => {
  let pages = [
    {
      label: "Banner Image",
      details: "Personalize the events list with a banner image.",
      isExternal: false,
      url: "hero",
      hidden: false,
    },
    {
      label: "Organization Links",
      details: "Display links to your website, social profiles, and more.",
      isExternal: false,
      url: "links",
      hidden: false,
    },
  ];
  return pages?.filter?.((p) => !p.hidden);
};

export const privacyForm = (context, organizationSettings) => {
  if (context) {
    let form = [
      {
        type: "vertical xx-large-gap",
        fields: [
          {
            label: "Tournament Visibility",
            value: (
              <GSToggle
                label="Hide events from all GolfStatus search results."
                trueDescription="Yes"
                falseDescription="No"
                onClick={context.toggleTournamentVisibility}
                value={organizationSettings?.hideTournamentSearch ?? false}
              />
            ),
            customView: true,
            isEditable: true,
          },
        ],
      },
    ];
    return form;
  }
};

export const getHeroForm = (context, selectedOrganization) => {
  if (context) {
    let form = [
      {
        type: "vertical xx-large-gap",
        fields: [
          {
            label: "Banner Image",
            value: (
              <GSFileSelect
                description="Tap or drag file to upload. Accepted Files: .JPG, .PNG, .GIF"
                setSelectedFiles={context?.setLogo}
                removeSourceItem={context?.removeLogo}
                editImage={() => {
                  context?.editImage()}}
                sourceList={context?.getLogo?.()}
                accept=".jpg, .jpeg, .png, mp4"
                title={
                  <GSButton
                    buttonIcon={faArrowCircleUp}
                    title="Upload"
                  ></GSButton>
                }
              />
            ),
            customView: true,
            failedValidation: context?.validationFailed,
            isEditable: true,
          },
        ],
      },
    ];
    return form;
  }
};

export const getPaymentsForm = (context, selectedOrganization, selectedAccount) => {
  if (context) {
    let achHintText = '';
    let sectionActions = [];

    if (selectedAccount?.status) {
      if (selectedAccount.status === 'verified') {
        achHintText = 'Verified';
      } else if (selectedAccount.status === 'pending') {
        achHintText = 'Pending Verification';
        sectionActions.push({
          title: "verify account",
          type: "green no-wrap",
          actionIcon: faUserShield,
          actionClick: context.verifyBankAccount,
        });
      } else if (selectedAccount.status === 'failed') {
        achHintText = 'Verification Failed';
      }
    }

    let accountType = '';
    if (selectedAccount?.accountType) {
      const str = selectedAccount?.accountType;
      accountType = str.charAt(0).toUpperCase() + str.slice(1);
    }

    let form = [
      {
        type: "vertical xx-large-gap",
        title: "Bank Account",
        sectionActions,
        fields: [
          {
            label: "Bank Account",
            description: selectedAccount?.accountLastFour
              ? `${accountType} Account Ending in *${selectedAccount?.accountLastFour}`
              : "Receive direct tournament payouts to your bank account.",
            align: "align-start",
            value: selectedAccount?.accountLastFour ? (
                <GSButton
                  buttonIcon={faLinkSlash}
                  title="disconnect account"
                  onClick={(e) => {
                    context?.removeBankAccount?.();
                  }}
                  type="grey"
                />
              ) : (
                <GSButton
                  buttonIcon={faLink}
                  title="connect bank account"
                  onClick={(e) => {
                    context?.connectBankAccount?.();
                  }}
                  type="black"
                />
              ),
            hintText: achHintText,
            customView: true,
            failedValidation: context?.validationFailed,
            isEditable: true,
          },
        ],
      }
    ];

    if (!selectedAccount?.status) {
      form.push(
        {
          type: "vertical xx-large-gap",
          title: "Stripe",
          fields: [
            {
              label: "Stripe Account",
              description: selectedOrganization?.stripeId
                ? selectedOrganization?.stripeId
                : "Receive direct tournament payouts through a connected Stripe account.",
              align: "align-start",
              value: selectedOrganization?.stripeId ? (
                <GSButton
                  buttonIcon={faLinkSlash}
                  title="disconnect account"
                  onClick={(e) => {
                    context?.removeStripeAccount?.();
                  }}
                  type="grey"
                />
              ) : (
                <GSButton
                  buttonIcon={faLink}
                  title="connect stripe account"
                  onClick={(e) => {
                    context?.connectStripe?.();
                  }}
                  type="black"
                />
              ),
              customView: true,
              failedValidation: context?.validationFailed,
              isEditable: true,
            },
          ],
        }
      )
    }

    return form;
  }
};

export const getLinksForm = (context, orgLinks) => {
  const { validLink } = validations;
  if (context) {
    let form = [
      {
        type: "vertical xx-large-gap",
        fields: [
          {
            label: "Organization links",
            value: (
              <GSItemList
                type="vertical medium-gap grey-empty-list rounded-empty-list"
                items={orgLinks}
                listItem={(item) => (
                  <OrganizationLinkItem
                    {...item}
                    removeLink={context.removeLink}
                  />
                )}
                itemSelected={context.linkSelected}
                emptyMessage={context.getEmptyList()}
              />
            ),
            customView: true,
            isEditable: true,
          },
          {
            label: "Link URL",
            placeholder: "Link URL",
            value: context?.getNewLinkText?.(),
            failedValidation: context?.validationFailed,
            onChange: (e) => {
              context.setNewLinkText(e.target.value);
            },
            validation: {
              isValid: validLink,
              invalidLabel: "Not a valid link",
            },
            isEditable: true,
            rightIcon: faExternalLinkSquareAlt,
            rightIconClick: () => {
              context?.linkSelected?.({ website: context?.getNewLinkText?.() });
            },
            hintText: "e.g. https://www.instagram.com/golf_status",
          },
          {
            value: (
              <GSButton
                type="black full"
                title="add link"
                onClick={context?.addLink}
                isDisabled={!context.formIsValid?.() || context.getNewLinkText?.() === ""}
              />
            ),
            customView: true,
            isEditable: true,
          },
        ],
      },
    ];
    return form;
  }
};
